import React, { useEffect, useState } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useParams } from "react-router-dom";
import { getAllFranchise } from "../apis/franchise";
import { createWorkData, getWorkFranchise, updateWork } from "../apis/workApis";
import toast from "react-hot-toast";

const WorkForm = () => {
  const { fId, tId } = useParams();
  const [franchise, setFranchise] = useState(null);
  const [work, setWork] = useState(null);
  const [assigns, setAssigns] = useState([]);
  //   const [activeTab, setActiveTab] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    date: "",
    type: "",
    value: "",
    document: null,
  });

  const [showForm, setShowForm] = useState(true); // toggle right form

  /* ---------------- STATUS → PERCENTAGE ---------------- */
  const getPercentage = () => {
    if (!work || !franchise || !work.team) return 0;

    /* ---------- PAYMENT TEAM ---------- */
    if (work.team.name === "Payment") {
      const total = franchise.totalPayment;
      if (total <= 0) return 100;

      const received =
        work.datas.reduce((acc, cur) => acc + Number(cur.value || 0), 0) +
        franchise.initPayment;

      return Math.min(Math.round((received / total) * 100), 100);
    }

    /* ---------- OTHER TEAMS ---------- */
    const fields = work.team.fields || [];
    if (fields.length === 0) return 0;

    const completedCount = fields.filter((field) =>
      work.datas.some(
        (d) =>
          d.type === field &&
          d.value !== undefined &&
          d.value !== null &&
          d.value !== ""
      )
    ).length;

    return Math.round((completedCount / fields.length) * 100);
  };

  /* ---------------- FETCH DATA ---------------- */

  const fetchData = async () => {
    try {
      const res = await getAllFranchise();
      const selectedFranchise = res.data.find((f) => f._id === fId);
      setFranchise(selectedFranchise);
      const resWork = await getWorkFranchise(fId, tId);

      setWork(resWork.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [fId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      data.append("type", formData.type);
      data.append("value", formData.value);
      data.append("document", formData.document);
      await createWorkData(work._id, data);
      if (work.team.name === "Payment") {
        const total = franchise.totalPayment || 0;
        

        const received =
          work.datas.reduce((acc, cur) => acc + Number(cur.value || 0), 0) +
          Number(formData?.value || 0)
          Number(franchise.initPayment||0);

        if(total <= received){
          await updateWork(work._id,{status:"completed"})
        }else{
          await updateWork(work._id,{status:"in progress"})
        }
      }else{
        const fields = work.team.fields || [];

        const completedCount = fields.filter((field) =>
          work.datas.some(
            (d) =>
              d.type === field &&
              d.value !== undefined &&
              d.value !== null &&
              d.value !== ""
          )
        ).length;
        if(fields === completedCount){
          await updateWork(work._id,{status:"completed"})
        }else{
          await updateWork(work._id,{status:"in progress"})
        }
      }
      
      fetchData();
      setFormData({ date: "", type: "", value: "", document: null });
      toast.success("Submit successfully");
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  const statusColor = (status) => {
    if (status === "completed") return "bg-green-100 text-green-600";
    if (status === "pending") return "bg-yellow-100 text-yellow-600";
    if (status === "in progress") return "bg-blue-100 text-blue-600";
    return "bg-gray-300 text-gray-600";
  };

  if (loading) {
    return <div className="p-10 text-center">Loading...</div>;
  }

  const percentage = getPercentage(work?.status);

  return (
    <div className=" p-4 min-h-screen">
      {/* ---------------- TOP FRANCHISE DETAIL ---------------- */}
      <div className="bg-white shadow rounded-md p-6 flex flex-col md:flex-row md:justify-between gap-6 mb-6 relative">
        <div className=" flex">
          <div>
            <h1 className="text-2xl font-bold text-gray-800">
              {franchise?.franchiseName}
            </h1>
            <p className="text-gray-600">Location: {franchise?.location}</p>
            <p className="text-gray-600">Owner: {franchise?.name}</p>
            {work?.team?.name === "Payment" && franchise?.totalPayment && (
              <p className="text-gray-600">
                Total Payment: {franchise.totalPayment}
              </p>
            )}
          </div>
          <div className="w-28  ml-10">
            <CircularProgressbar
              value={percentage}
              text={`${percentage}%`}
              strokeWidth={8}
              styles={buildStyles({
                textColor: "#dc2626",
                pathColor: "#dc2626",
                trailColor: "#e5e7eb",
              })}
            />
          </div>
        </div>
        <span className={"text-center bg-gray-300 font-medium px-3 py-1 rounded-xl absolute right-5 capitalize top-5" + statusColor(work?.status)}>
          {work?.status}
        </span>
      </div>

      {/* ---------------- MAIN CONTENT ---------------- */}
      <div className="flex flex-col-reverse md:flex-row gap-6">
        {/* ---------------- LEFT TABLE ---------------- */}
        <div className="flex-1 bg-white rounded-md shadow p-6 overflow-x-auto">
          <h2 className="text-xl font-bold text-red-600 mb-4">
            {work?.team?.name} History
          </h2>

          {work?.team?.name === "Payment" && (
            <div className="bg-gray-200 rounded-md px-4 py-2 flex justify-between mb-4 font-medium">
              <span>
                Total: {franchise?.totalPayment} <br /> Advance:{" "}
                {franchise?.initPayment}
              </span>
              <span>
                Received:{" "}
                {work.datas.reduce((acc, cur) => acc + Number(cur.value), 0)}
              </span>
              <span>
                Balance:{" "}
                {franchise?.totalPayment -
                  (work.datas.reduce((acc, cur) => acc + Number(cur.value), 0) +
                    franchise?.initPayment)}
              </span>
            </div>
          )}

          <table className="w-full border-collapse border">
            <thead className="bg-red-600 text-white">
              <tr>
                <th className="p-2 border">S.No</th>
                <th className="p-2 border">Date</th>
                <th className="p-2 border">Type</th>
                <th className="p-2 border">
                  {work?.team?.name === "Payment" ? "Amount" : "Value"}
                </th>
                <th className="p-2 border">Document</th>
              </tr>
            </thead>
            <tbody>
              {work.datas.length > 0 ? (
                work.datas.map((item, idx) => (
                  <tr key={idx} className="text-center border-t">
                    <td>{idx + 1}</td>
                    <td>{new Date(item.date).toLocaleDateString("en-GB")}</td>
                    <td>{item.type}</td>
                    <td>{item.value}</td>
                    <td>
                      {item.document ? (
                        <a
                          href={item.document}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 underline"
                        >
                          View
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="p-4 text-center text-gray-500">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="w-full md:w-80 h-fit bg-white rounded-md shadow p-6">
          <h3 className="text-xl font-bold text-red-600 mb-4">
            Add {work?.team?.name} Entry
          </h3>
          <form onSubmit={handleSubmit} className="space-y-4">
            {/* <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              /> */}
            {work?.team?.fields?.length ? (
              <select
                className="w-full border rounded px-3 py-2"
                onChange={(e) =>
                  setFormData({ ...formData, type: e.target.value })
                }
              >
                <option value="" disabled>-- Select ---</option>
                {work?.team?.fields.map((f) => (
                  <option value={f} className=" capitalize">
                    {f}
                  </option>
                ))}
              </select>
            ) : (
              <input
                type="text"
                name="type"
                placeholder="Type"
                value={formData.type}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
            )}
            <input
              type={work?.team?.name === "Payment" ? "number" : "text"}
              name="value"
              placeholder={work?.team?.name === "Payment" ? "Amount" : "Value"}
              value={formData.value}
              onChange={handleChange}
              required
              className="w-full border rounded px-3 py-2"
            />
            <input
              type="file"
              name="document"
              onChange={(e) =>
                setFormData({ ...formData, document: e.target.files[0] })
              }
              className="w-full border rounded px-3 py-2"
            />
            <div className="flex justify-end gap-3 pt-2">
              {/* <button
                type="button"
                onClick={() => setShowForm(false)}
                className="px-4 py-2 rounded border"
              >
                Cancel
              </button> */}
              <button
                type="submit"
                className="px-4 py-2 bg-red-600 text-white rounded"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default WorkForm;
